// Theme toggle and language menu wiring for the splash/shell pages.
(function () {
  const root = document.documentElement;
  const mql = window.matchMedia("(prefers-color-scheme: light)");

  function applyTheme(mode) {
    const isLight =
      mode === "light" || (mode === "system" && mql.matches);
    root.setAttribute("data-theme", isLight ? "light" : "dark");
    document.querySelectorAll("[data-theme-icon]").forEach((el) => {
      el.className = isLight ? "ph-fill ph-sun" : "ph-fill ph-moon-stars";
    });
    try {
      localStorage.setItem("propai:theme", mode);
    } catch (_) {}
  }

  const stored = (() => {
    try {
      return localStorage.getItem("propai:theme");
    } catch (_) {
      return null;
    }
  })();
  // Accept light / dark / system; default to dark
  applyTheme(stored === "light" || stored === "dark" || stored === "system" ? stored : "dark");

  // System preference change — re-apply if mode is "system"
  mql.addEventListener("change", () => {
    try {
      const cur = localStorage.getItem("propai:theme");
      if (cur === "system") applyTheme("system");
    } catch (_) {}
  });

  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-theme-toggle]");
    if (!t) return;
    const next = root.getAttribute("data-theme") === "light" ? "dark" : "light";
    applyTheme(next);
  });
})();
